var _rect, _g, _text, _text2, _text3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKcDesignSystem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 200",
    width: 350,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 200,
    rx: 24,
    fill: "#2c2c6c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4db5ff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#4db5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 40,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#1f1f38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 40,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1f1f38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 90,
    width: 90,
    height: 40,
    rx: 8,
    fill: "#1f1f38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 90,
    width: 40,
    height: 40,
    rx: 8,
    fill: "rgba(77,181,255,0.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 140,
    width: 140,
    height: 20,
    rx: 10,
    fill: "#1f1f38"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 105,
    fontFamily: "Poppins, sans-serif",
    fontSize: 22,
    fontWeight: 600,
    fill: "#ffffff"
  }, "Design")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 130,
    fontFamily: "Poppins, sans-serif",
    fontSize: 22,
    fontWeight: 600,
    fill: "#ffffff"
  }, "System")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 152,
    fontFamily: "Poppins, sans-serif",
    fontSize: 12,
    fill: "rgba(255,255,255,0.6)"
  }, "23 components")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKcDesignSystem);
export default __webpack_public_path__ + "static/media/KcDesignSystem.647c1941f1e973a82f803f9384222b83.svg";
export { ForwardRef as ReactComponent };